import ChangeCase from 'change-case';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { fetchEnvActivities } from '../../../app-main/actions/env';
import { BookingSummaryItem } from '../../common/items/BookingSummaryItem';

const mapStateToProps = ({ env }) => ({ env });

export const BookingSummaryActivity = connect(mapStateToProps)(
  ({ env, dispatch, booking }) => {
    const envActivity = (env?.activities || []).find(
      (a) => a.id === booking.tags.activity
    );

    const localizedActivity =
      envActivity?.dropdown || ChangeCase.titleCase(booking.tags.activity);

    useEffect(() => {
      const shouldFetchActivities =
        !!env && !env.isFetching && isEmpty(env.activities);

      if (shouldFetchActivities) {
        dispatch(fetchEnvActivities());
      }
    }, [env?.isFetching]);

    return (
      !!env?.activities && (
        <BookingSummaryItem
          testingId='booking-summary-activity'
          label={
            <FormattedMessage
              id='inbox.summary_props.activity'
              defaultMessage='Activity'
            />
          }
        >
          {localizedActivity}
        </BookingSummaryItem>
      )
    );
  }
);

BookingSummaryActivity.propTypes = {
  booking: PropTypes.object.isRequired,
  env: PropTypes.shape({
    activities: PropTypes.array
  }),
  dispatch: PropTypes.func
};
